var map = {
	"./Aegis.webp": 6724,
	"./Beep.webp": 3793,
	"./Ben.webp": 6302,
	"./Bits.webp": 6093,
	"./Boo.webp": 6115,
	"./Buck.webp": 4242,
	"./Cactus.webp": 2106,
	"./Clank.webp": 3846,
	"./Don.webp": 9010,
	"./Dust.webp": 7121,
	"./Ember.webp": 8740,
	"./Ethan.webp": 7107,
	"./Fan.webp": 86,
	"./Fang.webp": 359,
	"./Flap.webp": 882,
	"./Groan.webp": 9182,
	"./Howl.webp": 6515,
	"./Jade.webp": 335,
	"./Kong.webp": 5876,
	"./Lotus.webp": 6020,
	"./Mimic.webp": 5242,
	"./Min.webp": 8879,
	"./Mina.webp": 1966,
	"./Nib.webp": 8418,
	"./Nova.webp": 3575,
	"./Pearl.webp": 7459,
	"./Pew.webp": 6011,
	"./Pip.webp": 8562,
	"./Plop.webp": 2810,
	"./Pot.webp": 6372,
	"./Puff.webp": 3534,
	"./Rattle.webp": 9639,
	"./Rune.webp": 7161,
	"./Sage.webp": 7985,
	"./Snap.webp": 6105,
	"./Thorn.webp": 6238,
	"./Tusk.webp": 2432,
	"./Twig.webp": 872,
	"./User.webp": 7358,
	"./Viking.webp": 4503,
	"./Void.webp": 2439,
	"./Wisp.webp": 970,
	"./Zzz.webp": 2281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3450;